import React, { Component } from 'react';
import Topnavbar from '../components/topnavbar/Topnavbar';
import Footer from '../components/Footer/Footer';
import Pagetop from '../components/Pagetop/Pagetop';
import Allphotos from '../components/Allphotos/Allphotos';

class Photogallery extends Component {
    componentDidMount(){
        window.scroll(0,0)
    }
    render() {
        return (
            <div>
                <Topnavbar title="Our gallery" />
                <Pagetop title="Our gallery"/>
                <Allphotos/>
                <Footer/>
                
            </div>
        );
    }
}

export default Photogallery;